import { DiscoverCard } from "../components/DiscoverCard"
import React, { useState, useEffect, useRef } from 'react';
import { Heart, X, MapPin, Star, Clock, Flame, Zap, Gift, Trophy, Target, Filter, Shuffle, Bookmark, Share2, Eye, TrendingUp, Award, Sparkles, Volume2, VolumeX } from 'lucide-react';
import ApiService from "../services/productService"
import { dispensaries,strains  } from "../data/data";
import API_URL from "../config/ApiUrl";
import { AchievementsCard } from "../components/AchievementsCard";
import { getProductImage } from "../static/ProductPlaceHolder";
import AuthGate from "../auth/AuthGate";
import { useUser } from "../context/UserContext";
import { THCLeaderboardPage } from "./THCLeaderboardPage";
import { useTheme } from "../arrangement/ThemeContext";
const transformApiProduct = (apiProduct) => {
  console.log('apiProduct', apiProduct)
  return {
    id: apiProduct.id,
    name: apiProduct.name,
    type: apiProduct.type || apiProduct.attributes?.strain_type || 'Hybrid',
    thc: apiProduct.attributes?.THC || apiProduct.thc || 'N/A',
    cbd: apiProduct.attributes?.CBD || apiProduct.cbd || 'N/A',
    price: `$${apiProduct.price || '0'}`,
    priceRange: `$${(apiProduct.price - 5) || 0}-${(apiProduct.price + 5) || 0}`,
    dispensary: apiProduct.dispensary || 'Local Dispensary',
    distance: "1.2 miles",
    image: apiProduct.coverImage?.imageUrl || apiProduct.images?.[0]?.imageUrl || getProductImage(apiProduct.type),
    effects: apiProduct.effects || ["Relaxed", "Happy"],
    flavors: apiProduct.flavors || ["Natural"],
    rating: apiProduct.avg_rating || 4.0,
    reviews: apiProduct.review_count || 0,
    inStock: apiProduct.stock_quantity > 0,
    dealType: apiProduct.deal_type || null,
    discount: apiProduct.discount || null,
    isNew: apiProduct.is_new || false,
    isTrending: apiProduct.is_trending || false,
    matchScore: Math.floor(Math.random() * 20) + 80,
    description: apiProduct.description || `Premium ${apiProduct.name} for the best experience`,
    category: apiProduct.category || apiProduct.attributes?.category || 'Flower',
    attributes: apiProduct.attributes,
    lab: apiProduct.lab_info || "Lab tested for purity and potency"
  };
};



const StatsCard = ({ icon, label, value, trend, color, isMobile, colors }) => (
  
  <div style={{
    background: colors.bgTertiary,
    padding: isMobile ? '16px' : '20px',
    borderRadius: '16px',
    border: `1px solid ${colors.border}`,
    textAlign: 'center',
    transition: 'all 0.3s ease'
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.borderColor = color;
  }}
  onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.borderColor = colors.border;
    }}>
    <div style={{
      fontSize: isMobile ? '24px' : '32px',
      marginBottom: '8px'
    }}>
      {icon}
    </div>
    <div style={{
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: '700',
      color: color,
      marginBottom: '4px'
    }}>
      {value}
    </div>
    <div style={{
      fontSize: isMobile ? '11px' : '12px',
      color: colors.textSecondary,
      marginBottom: '4px'
    }}>
      {label}
    </div>
    {trend && (
      <div style={{
        fontSize: '11px',
        color: '#00d4aa',
        fontWeight: '600'
      }}>
        {trend}
      </div>
    )}
  </div>
);

export function DiscoverPage() {
  const [currentProducts, setCurrentProducts] = useState([]);
  const [profileData, setProfileData] = useState({ achievements: [] });
  const [achievementsLoading, setAchievementsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { isAuthenticated } = useUser();

  const { colors } = useTheme();

  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All Products');

  const [swipeDirection, setSwipeDirection] = useState(null);
  // Updated: Remove session-based liked products state
  const [passedProducts, setPassedProducts] = useState([]);
  const [streak, setStreak] = useState(0);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [showStats, setShowStats] = useState(false);
  const [sessionTime, setSessionTime] = useState(0);

  const [reviewedProducts, setReviewedProducts] = useState([]);
  const [reviewedProductsLoading, setReviewedProductsLoading] = useState(false);

  // Add new state for total stats
  const [totalReviewedCount, setTotalReviewedCount] = useState(0);
  const [totalLikedCount, setTotalLikedCount] = useState(0);

  const [products, setProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalProducts, setTotalProducts] = useState(0);
  
  const [currentView, setCurrentView] = useState('leaderboard'); // Default to leaderboard

  // Filters
  const [sortBy, setSortBy] = useState('rating');
  const [category, setCategory] = useState(null);

  const streakRef = useRef(0);

  // Add mobile detection effect
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Session timer
  useEffect(() => {
    const timer = setInterval(() => {
      setSessionTime(prev => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Sound effects (mock)
  const playSound = (type) => {
    if (!soundEnabled) return;
    console.log(`Playing ${type} sound`);
  };

  useEffect(() => {
    if (currentView === 'swipe') {  // ← ADD THIS CHECK
      loadProducts(1, true);
      loadReviewedProducts();
      fetchAchievements();
    }
  }, [sortBy, category, currentView]);

  useEffect(() => {
    if (products.length > 0) {
      setCurrentProducts(products.slice(currentIndex));
    }
  }, [products, currentIndex]);

  // Updated loadReviewedProducts to calculate total stats
  const loadReviewedProducts = async () => {
    try {
      setReviewedProductsLoading(true);
      const response = await ApiService.getReviewedProducts(1, 100); // Get more products for accurate counting
      const transformedProducts = response.products.map(product => ({
        ...transformApiProduct(product),
        userRating: product.user_rating,
        reviewedAt: product.reviewed_at
      }));
      
      setReviewedProducts(transformedProducts);
      
      // Calculate total stats
      setTotalReviewedCount(transformedProducts.length);
      setTotalLikedCount(transformedProducts.filter(product => 
        product.userRating >= 4
      ).length);
      
    } catch (error) {
      console.error('Error loading reviewed products:', error);
    } finally {
      setReviewedProductsLoading(false);
    }
  };

  const fetchAchievements = async () => {
    try {
      setAchievementsLoading(true);
      const response = await fetch(`${API_URL}/api/achievements`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result.success) {
        setProfileData(result.data);
      } else {
        console.error('Failed to fetch achievements:', result.error);
        setProfileData({ achievements: [] });
      }
    } catch (error) {
      console.error('Error fetching achievements:', error);
      setProfileData({ achievements: [] });
    } finally {
      setAchievementsLoading(false);
    }
  };

  const loadProducts = async (page = 1, reset = false) => {
    try {
      setLoading(true);
      const response = await ApiService.getAllDiscoverProducts(page, 10, sortBy, category);
      console.log('products response: ', response.products);
      const transformedProducts = response.products.map(transformApiProduct);
      console.log('products response: ', transformedProducts);
      
      if (reset) {
        setAllProducts(transformedProducts);
        setFilteredProducts(transformedProducts);
        setProducts(transformedProducts);
        setCurrentIndex(0);
      } else {
        const newAllProducts = [...allProducts, ...transformedProducts];
        setAllProducts(newAllProducts);
        setFilteredProducts(newAllProducts);
        setProducts(prev => [...prev, ...transformedProducts]);
      }
      
      setCurrentPage(response.pagination.current_page);
      setHasMore(response.pagination.has_next);
      setTotalProducts(response.pagination.total_products);
      setError(null);
    } catch (err) {
      setError('Failed to load products');
      console.error('Error loading products:', err);
    } finally {
      setLoading(false);
    }
  };

  const filterProducts = (filterType) => {
    setActiveFilter(filterType);
    
    let filtered = [];
    
    if (filterType === 'All Products') {
      filtered = allProducts;
    } else {
      const typeMap = {
        'Flower': ['flower', 'indica', 'sativa', 'hybrid'],
        'Edibles': ['edible', 'baked goods', 'gummies', 'chocolates'],
        'Vapes': ['vape', 'cartridge', 'pen'],
        'Concentrates': ['concentrate', 'wax', 'shatter', 'rosin', 'hash']
      };
      
      const typesToMatch = typeMap[filterType] || [];
      
      filtered = allProducts.filter(product => {
        if (product.type && typesToMatch.includes(product.type.toLowerCase())) {
          return true;
        }
        
        if (product.category && typesToMatch.includes(product.category.toLowerCase())) {
          return true;
        }
        
        if (product.attributes?.category && typesToMatch.includes(product.attributes.category.toLowerCase())) {
          return true;
        }
        
        if (filterType === 'Flower' && product.attributes?.strain_type) {
          return typesToMatch.includes(product.attributes.strain_type.toLowerCase());
        }
        
        return false;
      });
    }
    
    setFilteredProducts(filtered);
    setProducts(filtered);
    setCurrentIndex(0);
    setSwipeDirection(null);
  };

  useEffect(() => {
    if (currentView !== 'swipe') return;
    
    const remainingCards = products.length - currentIndex;
    if (remainingCards <= 3 && hasMore && !loading) {
      loadProducts(currentPage + 1, false);
    }
  }, [currentIndex, products.length, hasMore, loading, currentPage, currentView]);

  // Updated handleSwipe function
  const handleSwipe = async (direction, velocity, rating = null) => {
    const currentProduct = products[currentIndex];
    if (!currentProduct) return;

    setSwipeDirection(direction);

    try {
      let finalRating = rating;
      if (!rating) {
        if (direction === 'right') {
          finalRating = velocity === 'hard' ? 5 : 4;
        } else {
          finalRating = velocity === 'hard' ? 1 : 3;
        }
      }
      
      await ApiService.createReview(currentProduct.id, finalRating, currentProduct.effects);

      console.log(`${direction === 'right' ? 'Liked' : 'Passed'} ${currentProduct.name} with ${finalRating}/10 rating`);
      
      // Update reviewed products list immediately
      const newReviewedProduct = {
        ...currentProduct, 
        userRating: finalRating,
        reviewedAt: new Date().toISOString()
      };
      
      setReviewedProducts(prev => [newReviewedProduct, ...prev]);
      
      // Update total counts
      setTotalReviewedCount(prev => prev + 1);
      if (finalRating >= 4) {
        setTotalLikedCount(prev => prev + 1);
        setStreak(prev => prev + 1);
      } else {
        setStreak(0);
      }

      // Remove current product and reset swipe direction after animation
      setTimeout(() => {
        setCurrentIndex(prev => prev + 1);
        setSwipeDirection(null);
      }, 600);
    } catch (error) {
      console.error('Error creating review:', error);
      setTimeout(() => {
        setSwipeDirection(null);
      }, 600);
    }
  };

  const NavigationTabs = () => (
    <div style={{
      background: colors.bgTertiary,
      borderBottom: `1px solid ${colors.border}`,
      padding: '0 32px',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <div style={{
        display: 'flex',
        background: colors.bgCard,
        borderRadius: '12px',
        padding: '4px',
        margin: '16px 0'
      }}>
        <button
          onClick={() => setCurrentView('leaderboard')}
          style={{
            padding: isMobile ? '10px 20px' : '12px 24px',
            background: currentView === 'leaderboard' 
              ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' 
              : 'transparent',
            color: currentView === 'leaderboard' ? colors.bgPrimary : colors.textPrimary,
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: isMobile ? '14px' : '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease'
          }}
        >
          <Trophy size={isMobile ? 16 : 18} />
          Product Leaderboard
        </button>
        
        <button
          onClick={() => setCurrentView('swipe')}
          style={{
            padding: isMobile ? '10px 20px' : '12px 24px',
            background: currentView === 'swipe' 
              ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' 
              : 'transparent',
            color: currentView === 'swipe' ? colors.bgPrimary : colors.textPrimary,
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: isMobile ? '14px' : '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease'
          }}
        >
          <Heart size={isMobile ? 16 : 18} />
          Discovery Swipe
        </button>
      </div>
    </div>
  );

  
  if (!isAuthenticated && currentView === 'swipe') {
    return (
      <AuthGate 
        pageName="Discovery Swipe" 
        pageIcon={<Heart size={64} />}
        customMessage="Discover your perfect cannabis products with our smart recommendation engine"
        features={[
          { icon: <Heart size={20} />, text: "Swipe and rate thousands of products", color: "#ef4444" },
          { icon: <Star size={20} />, text: "Get personalized recommendations", color: "#fbbf24" },
          { icon: <TrendingUp size={20} />, text: "Build your taste profile", color: "#00d4aa" },
          { icon: <Award size={20} />, text: "Unlock achievements and rewards", color: "#8b5cf6" }
        ]}
      />
    );
  }

  if (loading && products.length === 0) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#000',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '48px',
            marginBottom: '16px',
            animation: 'spin 1s linear infinite'
          }}>🌿</div>
          <p>Loading products...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#000',
        color: 'white',
        textAlign: 'center'
      }}>
        <div>
          <h2>Oops! Something went wrong</h2>
          <p>{error}</p>
          <button 
            onClick={() => loadProducts(1, true)}
            style={{
              padding: '12px 24px',
              background: '#00d4aa',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              marginTop: '16px'
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const resetStack = () => {
    setCurrentIndex(0);
    setSwipeDirection(null);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: colors.bgPrimary,
      color: colors.textPrimary,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header with stats toggle */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: isMobile ? '16px 20px' : '24px 32px',
        background: colors.bgTertiary,
        borderBottom: `1px solid ${colors.border}`,
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '16px' : '0'
      }}>
        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
          <h1 style={{
            margin: '0 0 4px 0',
            fontSize: isMobile ? '24px' : '28px',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            Product Discovery
          </h1>
          <p style={{ margin: 0, color: colors.textSecondary, fontSize: isMobile ? '13px' : '14px' }}>
            Find your perfect cannabis products nearby
          </p>
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: isMobile ? '12px' : '16px', 
          alignItems: 'center',
          width: isMobile ? '100%' : 'auto',
          justifyContent: isMobile ? 'space-between' : 'flex-end'
        }}>
          <button
            onClick={() => setSoundEnabled(!soundEnabled)}
            style={{
              padding: isMobile ? '10px' : '12px',
              background: soundEnabled ? colors.bgTertiary : colors.bgCard,
              border: `1px solid ${colors.border}`,
              borderRadius: '12px',
              color: colors.textPrimary,
              cursor: 'pointer'
            }}>
            {soundEnabled ? <Volume2 size={isMobile ? 18 : 20} /> : <VolumeX size={isMobile ? 18 : 20} />}
          </button>
          
          <button
            onClick={() => setShowStats(!showStats)}
            style={{
              padding: isMobile ? '10px 16px' : '12px 20px',
              background: showStats ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' : '#1a1a1a',
              border: '1px solid #333',
              borderRadius: '12px',
              color: 'white',
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              fontWeight: '600'
            }}
          >
            <TrendingUp size={isMobile ? 14 : 16} style={{ marginRight: '8px', display: 'inline' }} />
            Stats
          </button>
        </div>
      </div>
      <NavigationTabs />

      {showStats && (
          <div style={{
            padding: isMobile ? '16px 20px' : '24px 32px',
            background: colors.bgSecondary,
            borderBottom: `1px solid ${colors.border}`,
            animation: 'slideDown 0.3s ease'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: isMobile ? '12px' : '16px',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <StatsCard
                icon="❤️"
                label="Products Liked"
                value={totalLikedCount}
                trend={totalLikedCount > 0 ? `${Math.round((totalLikedCount / Math.max(totalReviewedCount, 1)) * 100)}% liked` : null}
                color="#ef4444"
                isMobile={isMobile}
                colors={colors}
              />
              <StatsCard
                icon="🔥"
                label="Current Streak"
                value={streak}
                trend={streak > 0 ? `+${streak}` : null}
                color="#f59e0b"
                isMobile={isMobile}
                colors={colors}
              />
              <StatsCard
                icon="🎯"
                label="Total Reviewed"
                value={totalReviewedCount}
                trend={totalReviewedCount > 0 ? "Discovery Score" : null}
                color="#8b5cf6"
                isMobile={isMobile}
                colors={colors}
              />
              <StatsCard
                icon="⏱️"
                label="Session Time"
                value={formatTime(sessionTime)}
                color="#00d4aa"
                isMobile={isMobile}
                colors={colors}
              />
            </div>
          </div>
        )}



      {currentView === 'leaderboard' ? (
        // Import and render your THCLeaderboardPage component content here
        <THCLeaderboardPage />
      ) : (
        
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '20px 16px' : '40px 24px',
          display: isMobile ? 'flex' : 'grid',
          flexDirection: isMobile ? 'column' : undefined,
          gridTemplateColumns: isMobile ? undefined : '1fr 400px 1fr',
          gap: isMobile ? '24px' : '40px',
          alignItems: isMobile ? 'stretch' : 'center',
          minHeight: isMobile ? 'auto' : 'calc(100vh - 200px)'
        }}>
          {/* Left: Quick Actions - Mobile: Above cards */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: isMobile ? '16px' : '24px',
            order: isMobile ? 1 : 0
          }}>
            <div style={{
              background: colors.bgTertiary,
              padding: isMobile ? '16px' : '24px',
              borderRadius: '20px',
              border: `1px solid ${colors.border}`
            }}>
              <h3 style={{
                margin: '0 0 16px 0',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '600',
                color: colors.textPrimary,
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Filter size={isMobile ? 16 : 18} style={{ color: '#8b5cf6' }} />
                Quick Filters
              </h3>
              <div style={{ 
                display: isMobile ? 'flex' : 'flex',
                flexDirection: isMobile ? 'row' : 'column',
                flexWrap: isMobile ? 'wrap' : 'nowrap',
                gap: isMobile ? '8px' : '12px',
                justifyContent: isMobile ? 'center' : 'flex-start'
              }}>
                {['All Products', 'Flower', 'Edibles', 'Vapes', 'Concentrates'].map((filter, index) => (
                  <button
                    key={filter}
                    onClick={() => filterProducts(filter)}
                    style={{
                      padding: isMobile ? '8px 12px' : '12px 16px',
                      background: activeFilter === filter ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' : '#2a2a2a',
                      color: activeFilter === filter ? 'white' : '#e5e5e5',
                      border: '1px solid',
                      borderColor: activeFilter === filter ? '#00d4aa' : '#333',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '12px' : '14px',
                      fontWeight: '500',
                      textAlign: 'left',
                      transition: 'all 0.3s ease',
                      flex: isMobile ? '0 0 auto' : '1',
                      whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={(e) => {
                      if (activeFilter !== filter) {
                        e.currentTarget.style.background = '#333';
                        e.currentTarget.style.borderColor = '#00d4aa';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeFilter !== filter) {
                        e.currentTarget.style.background = '#2a2a2a';
                        e.currentTarget.style.borderColor = '#333';
                      }
                    }}
                  >
                    {filter}
                    {filter !== 'All Products' && !isMobile && (
                      <span style={{
                        marginLeft: '8px',
                        fontSize: '12px',
                        opacity: 0.7,
                        background: activeFilter === filter ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
                        padding: '2px 6px',
                        borderRadius: '10px'
                      }}>
                        {filter === 'Flower' && allProducts.filter(p => 
                          (p.type && ['flower', 'indica', 'sativa', 'hybrid'].includes(p.type.toLowerCase())) ||
                          (p.attributes?.strain_type && ['indica', 'sativa', 'hybrid'].includes(p.attributes.strain_type.toLowerCase()))
                        ).length}
                        {filter === 'Edibles' && allProducts.filter(p => 
                          (p.type && p.type.toLowerCase() === 'edible') ||
                          (p.attributes?.category && ['baked goods', 'gummies', 'chocolates'].includes(p.attributes.category.toLowerCase()))
                        ).length}
                        {filter === 'Vapes' && allProducts.filter(p => 
                          p.type && ['vape', 'cartridge', 'pen'].includes(p.type.toLowerCase())
                        ).length}
                        {filter === 'Concentrates' && allProducts.filter(p => 
                          p.type && ['concentrate', 'wax', 'shatter', 'rosin', 'hash'].includes(p.type.toLowerCase())
                        ).length}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {!isMobile && (
              <AchievementsCard 
                profileData={profileData} 
                loading={achievementsLoading} 
                isAuthenticated={isAuthenticated} 
              />
            )}
          </div>

          {/* Center: Card Stack */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: isMobile ? '24px' : '32px',
            order: isMobile ? 2 : 0
          }}>
            {/* Card Container */}
            <div style={{
              position: 'relative',
              width: '100%',
              height: isMobile ? '500px' : '600px',
              perspective: '1000px'
            }}>
              {products.length > currentIndex ? (
              products
                .slice(currentIndex, currentIndex + 3)
                .map((product, index) => (
                    <DiscoverCard
                      key={product.id}
                      product={product}
                      isTop={index === 0}
                      swipeDirection={index === 0 ? swipeDirection : null}
                      onSwipe={handleSwipe}
                      cardIndex={index}
                      isMobile={isMobile}
                    />
                  ))
                  .reverse()
              ) : (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  textAlign: 'center',
                  border: '2px dashed #333',
                  borderRadius: '24px',
                  padding: isMobile ? '24px' : '40px',
                  background: colors.bgTertiary,
                }}>
                  <div style={{ fontSize: isMobile ? '60px' : '80px', marginBottom: isMobile ? '16px' : '24px' }}>🎉</div>
                  <h3 style={{ 
                    fontSize: isMobile ? '22px' : '28px', 
                    fontWeight: '700', 
                    margin: '0 0 12px 0',
                    color: '#00d4aa'
                  }}>
                    Discovery Complete!
                  </h3>
                  <p style={{ 
                    color: '#888', 
                    margin: '0 0 24px 0',
                    fontSize: isMobile ? '14px' : '16px',
                    lineHeight: '1.5'
                  }}>
                    You've explored all available products in your area.
                    {!isMobile && <br />}
                    Check back later for new discoveries!
                  </p>
                  <button
                    onClick={resetStack}
                    style={{
                      padding: isMobile ? '14px 28px' : '16px 32px',
                      background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '16px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    <Shuffle size={isMobile ? 14 : 16} />
                    Discover Again
                  </button>
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: isMobile ? '12px' : '16px',
              justifyContent: 'center',
              flexWrap: isMobile ? 'wrap' : 'nowrap'
            }}>
              {/* 1 Star - Hate it */}
              <button
                style={{
                  width: isMobile ? '45px' : '50px',
                  height: isMobile ? '45px' : '50px',
                  borderRadius: '50%',
                  border: '3px solid #dc2626',
                  color: '#dc2626',
                  backgroundColor: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: currentProducts.length === 0 ? 0.3 : 1,
                  transition: 'all 0.3s ease',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600'
                }}
                onClick={() => handleSwipe("left", "hard", 1)}
                disabled={products.length <= currentIndex}
                onMouseEnter={(e) => {
                  if (currentProducts.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#dc2626';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#dc2626';
                }}
                title="1 Star - Hate it"
              >
                1★
              </button>

              {/* 2 Stars - Don't like it */}
              <button
                style={{
                  width: isMobile ? '48px' : '55px',
                  height: isMobile ? '48px' : '55px',
                  borderRadius: '50%',
                  border: '3px solid #f97316',
                  color: '#f97316',
                  backgroundColor: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: currentProducts.length === 0 ? 0.3 : 1,
                  transition: 'all 0.3s ease',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600'
                }}
                onClick={() => handleSwipe("left", "normal", 2)}
                disabled={products.length <= currentIndex}
                onMouseEnter={(e) => {
                  if (currentProducts.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#f97316';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#f97316';
                }}
                title="2 Stars - Don't like it"
              >
                2★
              </button>

              {/* 3 Stars - It's okay */}
              <button
                style={{
                  width: isMobile ? '52px' : '60px',
                  height: isMobile ? '52px' : '60px',
                  borderRadius: '50%',
                  border: '3px solid #eab308',
                  color: '#eab308',
                  backgroundColor: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: currentProducts.length === 0 ? 0.3 : 1,
                  transition: 'all 0.3s ease',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600'
                }}
                onClick={() => handleSwipe("left", "gentle", 3)}
                disabled={products.length <= currentIndex}
                onMouseEnter={(e) => {
                  if (currentProducts.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#eab308';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#eab308';
                }}
                title="3 Stars - It's okay"
              >
                3★
              </button>

              {/* 4 Stars - I like it */}
              <button
                style={{
                  width: isMobile ? '48px' : '55px',
                  height: isMobile ? '48px' : '55px',
                  borderRadius: '50%',
                  border: '3px solid #00d4aa',
                  color: '#00d4aa',
                  backgroundColor: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: currentProducts.length === 0 ? 0.3 : 1,
                  transition: 'all 0.3s ease',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600'
                }}
                onClick={() => handleSwipe("right", "normal", 4)}
                disabled={products.length <= currentIndex}
                onMouseEnter={(e) => {
                  if (currentProducts.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#00d4aa';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#00d4aa';
                }}
                title="4 Stars - I like it"
              >
                4★
              </button>

              {/* 5 Stars - Love it */}
              <button
                style={{
                  width: isMobile ? '45px' : '50px',
                  height: isMobile ? '45px' : '50px',
                  borderRadius: '50%',
                  border: '3px solid #f59e0b',
                  color: '#f59e0b',
                  backgroundColor: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: currentProducts.length === 0 ? 0.3 : 1,
                  transition: 'all 0.3s ease',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600'
                }}
                onClick={() => handleSwipe("right", "hard", 5)}
                disabled={products.length <= currentIndex}
                onMouseEnter={(e) => {
                  if (currentProducts.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#f59e0b';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#f59e0b';
                }}
                title="5 Stars - Love it!"
              >
                5★
              </button>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: isMobile ? '16px' : '24px',
              flexWrap: 'wrap',
              maxWidth: '500px',
              margin: '0 auto'
            }}>
              <div style={{ textAlign: 'center', fontSize: isMobile ? '10px' : '11px', color: '#666' }}>
                <div style={{ marginBottom: '4px' }}><strong>Swipe Fast</strong></div>
                <div>Left = 1⭐ | Right = 5⭐</div>
              </div>
              <div style={{ textAlign: 'center', fontSize: isMobile ? '10px' : '11px', color: '#666' }}>
                <div style={{ marginBottom: '4px' }}><strong>Swipe Gentle</strong></div>
                <div>Left = 3⭐ | Right = 4⭐</div>
              </div>
            </div>

            {/* Streak Indicator */}
            {streak > 0 && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: isMobile ? '10px 16px' : '12px 20px',
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                borderRadius: '20px',
                color: 'white',
                fontSize: isMobile ? '13px' : '14px',
                fontWeight: '600',
                animation: 'bounce 0.5s ease'
              }}>
                <Flame size={isMobile ? 14 : 16} />
                {streak} Like Streak!
              </div>
            )}
          </div>

          {/* Right: Reviewed Products - Mobile: Below cards */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: isMobile ? '16px' : '24px',
            order: isMobile ? 3 : 0
          }}>
            <div style={{
              background: colors.bgTertiary,
              padding: isMobile ? '16px' : '24px',
              borderRadius: '20px',
              border: `1px solid ${colors.border}`,
              maxHeight: isMobile ? '300px' : '400px',
              maxWidth: isMobile ? '100%' : '260px',
              overflowY: 'auto'
            }}>
              <h3 style={{
                margin: '0 0 16px 0',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Star size={isMobile ? 16 : 18} style={{ color: '#fbbf24' }} />
                Reviewed Products ({totalReviewedCount})
              </h3>
              
              {reviewedProductsLoading ? (
                <div style={{
                  textAlign: 'center',
                  padding: isMobile ? '30px 15px' : '40px 20px',
                  color: '#888'
                }}>
                  <div style={{ fontSize: isMobile ? '20px' : '24px', marginBottom: '12px' }}>⏳</div>
                  <p style={{ margin: 0, fontSize: isMobile ? '13px' : '14px' }}>
                    Loading your reviews...
                  </p>
                </div>
              ) : reviewedProducts.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  padding: isMobile ? '30px 15px' : '40px 20px',
                  color: '#888'
                }}>
                  <div style={{ fontSize: isMobile ? '32px' : '40px', marginBottom: '12px' }}>⭐</div>
                  <p style={{ margin: 0, fontSize: isMobile ? '13px' : '14px' }}>
                    Products you review will appear here
                  </p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '10px' : '12px' }}>
                  {reviewedProducts.slice(0, 8).map((product) => (
                    <div
                      key={`${product.id}-${product.reviewedAt}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: isMobile ? '10px' : '12px',
                        padding: isMobile ? '10px' : '12px',
                        background: colors.bgCard,
                        borderRadius: '12px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#333';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#2a2a2a';
                      }}
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        style={{
                          width: isMobile ? '45px' : '50px',
                          height: isMobile ? '45px' : '50px',
                          borderRadius: '8px',
                          objectFit: 'cover'
                        }}
                      />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                          fontSize: isMobile ? '13px' : '14px',
                          fontWeight: '600',
                          color: '#e5e5e5',
                          marginBottom: '2px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                          {product.name}
                        </div>
                        <div style={{
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#888',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <span>{product.price}</span>
                          <span>•</span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ 
                              color: product.userRating >= 4 ? '#00d4aa' : product.userRating >= 3 ? '#fbbf24' : '#ef4444',
                              fontWeight: '600'
                            }}>
                              {product.userRating}⭐
                            </span>
                          </div>
                        </div>
                      </div>
                      {!isMobile && (
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button style={{
                            padding: '6px',
                            background: '#333',
                            border: '1px solid #444',
                            borderRadius: '6px',
                            color: '#e5e5e5',
                            cursor: 'pointer'
                          }}>
                            <Eye size={12} />
                          </button>
                          <button style={{
                            padding: '6px',
                            background: '#333',
                            border: '1px solid #444',
                            borderRadius: '6px',
                            color: '#e5e5e5',
                            cursor: 'pointer'
                          }}>
                            <Share2 size={12} />
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile: Show achievements at bottom */}
            {isMobile && (
              <AchievementsCard 
                profileData={profileData} 
                loading={achievementsLoading} 
                isAuthenticated={isAuthenticated} 
              />
            )}
          </div>
        </div>
      )}
      {/* Global Styles */}
      <style>{`
        @keyframes bounce {
          0%, 20%, 53%, 80%, 100% {
            transform: translate3d(0, 0, 0);
          }
          40%, 43% {
            transform: translate3d(0, -8px, 0);
          }
          70% {
            transform: translate3d(0, -4px, 0);
          }
          90% {
            transform: translate3d(0, -2px, 0);
          }
        }
        
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Custom scrollbar */
        *::-webkit-scrollbar {
          width: 6px;
        }
        
        *::-webkit-scrollbar-track {
          background: #1a1a1a;
          border-radius: 3px;
        }
        
        *::-webkit-scrollbar-thumb {
          background: #333;
          border-radius: 3px;
        }
        
        *::-webkit-scrollbar-thumb:hover {
          background: #00d4aa;
        }
      `}</style>
    </div>
  );
}